import AUStates from './pt-BR/AU-states.json.js';
import CAStates from './pt-BR/CA-states.json.js';
import CNStates from './pt-BR/CN-states.json.js';
import CompanySize from './pt-BR/company-size.json.js';
import CompanyType from './pt-BR/company-type.json.js';
import countries from './pt-BR/countries.json.js';
import DEStates from './pt-BR/DE-states.json.js';
import HKStates from './pt-BR/HK-states.json.js';
import INStates from './pt-BR/IN-states.json.js';
import industry from './pt-BR/industry.json.js';
import interests from './pt-BR/interests.json.js';
import jobRole from './pt-BR/job-role.json.js';
import levelOfAWSUsage from './pt-BR/level-of-aws-usage.json.js';
import projectTimeline from './pt-BR/project-timeline.json.js';
import PTStates from './pt-BR/PT-states.json.js';
import USStates from './pt-BR/US-states.json.js';
import useCase from './pt-BR/use-case.json.js';
import languagePreference from './pt-BR/language-preference.json.js';
import Navatar from '../pt-BR/translation.json.js';

const dropdownsData = {
    ...AUStates,
    ...CAStates,
    ...CNStates,
    ...CompanySize,
    ...CompanyType,
    ...countries,
    ...DEStates,
    ...HKStates,
    ...INStates,
    ...industry,
    ...interests,
    ...jobRole,
    ...levelOfAWSUsage,
    ...projectTimeline,
    ...PTStates,
    ...USStates,
    ...useCase,
    ...Navatar.translation,
    ...languagePreference,
};

export { dropdownsData as default };
